/* ==========================================================================
   InputPanel > Client > Store > Reducer
   ========================================================================== */

/* Modules */
const { types } = require('./actions');

/* Initial state */
const initialState = {
    disabled: false,
    hidden: false,
    error: false,
    valid: false,
    value: null,
    isLoading: false,
    panel: false,
    panelType: null
};

/* Reducer */
function reducer(state = initialState, action) {
    switch (action.type) {
        case types.DISPLAY:
            return {
                ...state,
                hidden: false
            };
        case types.HIDE:
            return {
                ...state,
                hidden: true
            };
        case types.ENABLE:
            return {
                ...state,
                disabled: false
            };
        case types.DISABLE:
            return {
                ...state,
                disabled: true
            };
        case types.SET_ERROR:
            return {
                ...state,
                error: true
            };
        case types.RESET_STATUS:
            return {
                ...state,
                error: false
            };
        case types.TOGGLE_LOADING:
            return {
                ...state,
                isLoading: !state.isLoading
            };
        case types.SET_VALUE:
        case types.CHANGE_VALUE:
            return {
                ...state,
                value: action.payload
            };
        case types.CLEAR:
            return {
                ...state,
                value: null
            };
        case types.OPEN_PANEL:
            return {
                ...state,
                panelType: action.payload,
                panel: true
            };
        case types.CLOSE_PANEL:
            return {
                ...state,
                panelType: null,
                panel: false
            };
        case types.DESTROY:
        default:
            return state;
    }
}

/* Exports */
module.exports = {
    reducer
};
